'use strict';

var React = require('react');
var ReactForms = require('react-forms');
var Mapping = ReactForms.schema.Mapping;

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var Scalar = require('ofs/forms/scalars/Scalar');
var scalars = require('ofs/forms/scalars');

var SelectOne = require('ofs/forms/inputs/simple-choice');
var ToggleSelect = require('ofs/forms/inputs/toggle-select');

var buildLayout = require('./layout');

var messages = {
  SEARCH_ENQUIRE_OPTION: gettext("I'm interested in booking"),
  BOOKING_ENQUIRE_OPTION: gettext("I've got a question about an existing booking"),
  HOST_ENQUIRE_OPTION: gettext("I'd like to list my home"),
  GENERAL_ENQUIRE_OPTION: gettext("Other enquiries"),
  CALL_RES: gettext('Call reservations on %(telephone_number)s'),
  CALL_OTHER: gettext('Call our %(team_name)s team on %(telephone_number)s'),
  EMAIL: gettext('Email'),
  CALL: gettext('Call Me'),
  MESSAGE_LABEL: gettext('Message'),
  CONTACT_PREFERENCE_LABEL: gettext('How would you like us to contact you?')
};

var enquiryChoices = [
  {value: 'search_enquiry', name: messages.SEARCH_ENQUIRE_OPTION},
  {value: 'booking_enquiry', name: messages.BOOKING_ENQUIRE_OPTION},
  {value: 'host_enquiry', name: messages.HOST_ENQUIRE_OPTION},
  {value: 'general_enquiry', name: messages.GENERAL_ENQUIRE_OPTION}
];

var contactChoices = [
  {value: 'email', name: messages.EMAIL},
  {value: 'call', name: messages.CALL},
];

var topicMappings = {
  'search_enquiry': require('../mappings/search').mapping,
  'booking_enquiry': require('../mappings/booking').mapping,
  'host_enquiry': require('../mappings/host').mapping,
  'general_enquiry': require('../mappings/general').mapping
};

var contactMappings = {
  'email': require('../mappings/email').mapping,
  'call': require('../mappings/telephone').mapping
};

var buildSchema = function(topic, contactPreference, defaultValues) {
  var Component = buildLayout(topic, contactPreference);
  var topicMapping = topicMappings[topic](defaultValues);
  var contactMapping = contactMappings[contactPreference](defaultValues);

  var fields = Object.assign({
    enquiry_option: Scalar({
      input: <SelectOne options={enquiryChoices} />,
      defaultValue: topic,
      required: true,
      name: 'enquiry_option'
    })
  }, topicMapping, {
    message: scalars.TextScalar({
      label: messages.MESSAGE_LABEL,
      required: false
    }),
    contact_preference: Scalar({
      label: messages.CONTACT_PREFERENCE_LABEL,
      input: <ToggleSelect options={contactChoices} className="ignore-react-onclickoutside" />,
      defaultValue: 'email',
      required: true
    })
  }, contactMapping);

  return Mapping({ component: Component }, fields);
};

module.exports = buildSchema;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/generic/schema.jsx
 **/